// extracted by mini-css-extract-plugin
module.exports = {"Root":"chapters_Root__1QEQ0"};